import Card, { CardProps } from './Card';

export default Card;
export type { CardProps };
